module.exports = __webpack_public_path__ + "fonts/Lato-Thin.13fa4c60.woff";